import { useLocation, useParams } from "react-router-dom";

export function isBusinessStationPath(pathname: string): boolean {
  return /\/business\/\d+\/stations(\/|$)/.test(pathname);
}

export function getBusinessIdFromPath(pathname: string): number | undefined {
  const match = pathname.match(/\/business\/(\d+)\/stations/);
  return match ? +match[1] : undefined;
}

export function resolveStationRouteContext(
  params: Record<string, string | undefined>,
  pathname: string,
) {
  const isBusinessContext = isBusinessStationPath(pathname);
  const businessId = isBusinessContext
    ? getBusinessIdFromPath(pathname)
    : undefined;
  const stationId = params.stationId
    ? +params.stationId
    : !isBusinessContext && params.id && params.id !== "create"
      ? +params.id
      : undefined;
  const listPath = businessId
    ? `/business/${businessId}/stations`
    : "/stations";

  return { isBusinessContext, businessId, stationId, listPath };
}

export function getStationEditPath(
  stationId: number,
  businessId?: number,
): string {
  return businessId
    ? `/business/${businessId}/stations/${stationId}`
    : `/station/${stationId}`;
}

export function getStationCreatePath(businessId?: number): string {
  return businessId
    ? `/business/${businessId}/stations/create`
    : "/station/create";
}

export function getStationAssignAccountPath(
  stationId: number,
  businessId?: number,
): string {
  return businessId
    ? `/business/${businessId}/stations/${stationId}/assign/account`
    : `/station/assign/account/${stationId}`;
}

export function getStationAssignUserPath(
  stationId: number,
  businessId?: number,
): string {
  return businessId
    ? `/business/${businessId}/stations/${stationId}/assign/user`
    : `/station/assign/user/${stationId}`;
}

export function getStationTermsPath(
  stationId: number,
  businessId?: number,
): string {
  return businessId
    ? `/business/${businessId}/stations/${stationId}/terms-and-conditions`
    : `/station/${stationId}/terms-and-conditions`;
}

export function getStationPlanUsagePath(
  stationId: number,
  businessId?: number,
): string {
  return businessId
    ? `/business/${businessId}/stations/${stationId}/plan-usage`
    : `/station/${stationId}/plan-usage`;
}

export function useStationRouteContext() {
  const params = useParams();
  const { pathname } = useLocation();
  return resolveStationRouteContext(params, pathname);
}
